import { makeEnvironmentProviders } from '@angular/core';
import { API_BASE_URL } from '../tokens/api-base-url.token';

export const provideConfiguration = (apiBaseUrl: string) =>
  makeEnvironmentProviders([{ provide: API_BASE_URL, useValue: apiBaseUrl }]);
